import { Controller } from "stimulus";

// Segmented tabs for the class detail (lobby) screen — switches the active tab
// pill and shows the matching panel. Panels carry data-panel="<key>" matching
// each tab's data-tab="<key>".
export default class extends Controller {
  static targets = ["tab", "panel"];

  switch(event) {
    const key = event.currentTarget.dataset.tab;

    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("on", tab.dataset.tab === key);
    });

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== key;
    });
  }
}
